import { Button, Card, Space } from "antd";
import { ReactNode, useEffect } from "react";
import CustomModal from "../../../components/ui/CustomModal";
import Loader from "../../../components/ui/Loader";
import {
  useGetProtalSingleDepartmentQuery,
  useUpdatePortalStatusDepartmentMutation,
} from "../../../features/portal/settings/settingsApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";

export interface ModalConfirmProps<
  DataT = never,
  TypeT =
    | "SUCCESS"
    | "ADD"
    | "UPDATE"
    | "VIEW"
    | "CONFIRM"
    | "CONFIRM_FOR_APPROVAL"
    | "PRODUCT_ACTIVITY"
> {
  open: boolean;
  action?: boolean;
  buttonBgDeep?: boolean;
  handleClose: (val?: any) => void;
  type?: TypeT;
  data?: any;
  title?: ReactNode;
  subTitle?: ReactNode;
  buttonName?: string;
  loading?: boolean;
  children?: ReactNode;
}

export default function DepartmentStatusUpdateModal({
  title,
  action,
  buttonName,
  buttonBgDeep,
  subTitle,
  handleClose,
  children,
  type,
  data,
  loading,
  ...rest
}: ModalConfirmProps) {
  const {
    data: getProtalSingleDepartmentData,
    isError: getProtalSingleDepartmentIsError,
    error: getProtalSingleDepartmentError,
    isLoading: getProtalSingleDepartmentIsLoading,
  } = useGetProtalSingleDepartmentQuery(data?.id, { skip: !data?.id });
  const [
    updatePortalStatusDepartment,
    { isSuccess, isLoading, isError, error },
  ] = useUpdatePortalStatusDepartmentMutation();
  useError(
    getProtalSingleDepartmentIsError,
    getProtalSingleDepartmentError,
    "Single department get data failed"
  );
  useError(isError, error, "Department status updated failed");

  const handleActiveInactiveRole = () => {
    const newData = {
      is_published:
        getProtalSingleDepartmentData?.data?.is_published === 1 ? 0 : 1,
    };

    updatePortalStatusDepartment({
      data: newData,
      id: data?.id,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      toast(
        "success",
        `${
          getProtalSingleDepartmentData?.data?.is_published === 1
            ? `${getProtalSingleDepartmentData?.data?.name} has been marked as inactive successfully`
            : `${getProtalSingleDepartmentData?.data?.name} is now active again`
        }`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        {data?.id && getProtalSingleDepartmentIsLoading ? (
          <Loader />
        ) : (
          <Card className="w-full">
            <h4 className=" font-semibold text-[18px] text-[#5E718D] text-center">
              {`${
                getProtalSingleDepartmentData?.data?.is_published === 1
                  ? "Inactive"
                  : "Active"
              } ${getProtalSingleDepartmentData?.data?.name}!`}
            </h4>

            <div className=" font-normal text-[14px] text-[#5E718D] text-center">
              {`Are you sure you want to ${
                getProtalSingleDepartmentData?.data?.is_published === 1
                  ? "inactive"
                  : "active"
              } ${getProtalSingleDepartmentData?.data?.name} of department?`}
            </div>

            <Space className="flex justify-center gap-2 mt-6">
              <Button
                className="normal-dark-button modal-button"
                size="middle"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                onClick={handleActiveInactiveRole}
                loading={isLoading}
              >
                {`Yes, ${
                  getProtalSingleDepartmentData?.data?.is_published === 1
                    ? "Inactive"
                    : "Active"
                }`}
              </Button>
            </Space>
          </Card>
        )}
      </CustomModal>
    </>
  );
}
